const AXOS_VERSION='2211080937'
module.exports =  { AXOS_VERSION }
